/* eslint-disable @typescript-eslint/no-unused-vars */
import { Fade, Typography } from '@material-ui/core'
import { memo, useEffect, useState } from 'react'

import { Facility } from '../../types/accommodationFacilities'
import useStyles from './styles/FacilityItemCheckBox.styles'

interface FacilityItemCheckBoxProps {
  data: Facility
  index: number
  selectedIDs: string[]
  setSelectedIDs: React.Dispatch<React.SetStateAction<string[]>>
}

const FacilityItemCheckBox: React.FC<FacilityItemCheckBoxProps> = ({
  data,
  index,
  selectedIDs,
  setSelectedIDs
}) => {
  const classes = useStyles()
  const [active, setactive] = useState(data.selected)
  useEffect(() => {
    setSelectedIDs((prev) => {
      if (active) {
        // Add if not already included
        if (!prev.includes(data.id)) {
          return [...prev, data.id]
        }
        return prev
      } else {
        // Remove if included
        return prev.filter((id) => id !== data.id)
      }
    })
  }, [active])
  return (
    // <FormControlLabel
    //   className={classes.formControlItem}
    //   control={
    //     <Checkbox
    //       color="primary"
    //       checked={data.selected}
    //       onChange={() => onToggle(index)}
    //     />
    //   }
    //   label={getTranslate(data.label)}
    // />
    <div
      className={[classes.root, active ? classes.active : ''].join(' ')}
      onClick={() => {
        setactive(!active)
      }}>
      <Fade in={active} timeout={250}>
        <span className={classes.activeCircle} />
      </Fade>
      <Typography variant="h4">{data.label}</Typography>
    </div>
  )
}

export default memo(FacilityItemCheckBox)
